export default {
  showBtn: number => `View ${number} product${number !== 1 ? 's' : ''}`,
  closeFilter: `close filter`,
  clearAll: `Clear all`,
  filterBy: `Filter by`,
  showResults: 'Show results for'
}
